import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import "rxjs/add/operator/map";
import { switchMap } from "rxjs/operators/switchMap";

const API_ENDPOINT = environment.API_ENDPOINT;

export interface PresignedUrl {
  presigned_url: string;
  cdn_url: string;
}

@Injectable()
export class S3Service {
  patients: Observable<any>;

  constructor(private http: HttpClient) {}

  getDocumentUploadHash() {
    return this.http.post(API_ENDPOINT + "/froala_hash", { type: "document" });
  }

  getReportDocumentUploadHash(plan: number) {
    return this.http.post(API_ENDPOINT + "/froala_hash", {
      type: "report_document",
      plan,
    });
  }

  getPresignedUrl(path, file): Observable<PresignedUrl> {
    return this.http.post<PresignedUrl>(API_ENDPOINT + "/pre-signed-url", {
      path,
      file,
    });
  }

  putFileToS3(path, file: File): Observable<string> {
    return this.getPresignedUrl(path, file.name).pipe(
      switchMap((result) => {
        const headers = new HttpHeaders({ "Content-Type": file.type });
        return this.http
          .put(result.presigned_url, file, { headers: headers })
          .map(() => result.cdn_url);
      }),
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/s3.service.ts